import { useParams } from 'react-router-dom';
import useViewRealPlayQuery from 'features/realplays/services/queries/useViewRealplay';

const RealPlayViewLogic = () => {
  const { uuid } = useParams();
  const { isLoading } = useViewRealPlayQuery({ uuid });

  return { isLoading };
};

export default RealPlayViewLogic;
